// https://vuex.vuejs.org/en/state.html
import { TokenService } from '../services/storage.service'

export default {
  //
  apiRoot: '',
  configError: null,
  loginCredentials: {
    clientCode: null,
    accessKey: null,
    type: null,
    username: null
  },
  userProfile: TokenService.getUserProfile(),
  sales: [],
  agencies: [],
  agenciesList: [],
  agencyFilter: 'All',
  distributorsList: [],
  distributorFilter: 'All',
  brandsList: [],
  brandFilter: 'All',
  supplierSales: [],
  retailStoreSales: [],
  dateFrom: '',
  scheduleDateFrom: '',
  scheduleDateTo: '',
  dateTo: '',
  workOrderFilter: 'All',
  workOrders: ['All'],
  storeFilter: 'All',
  storeTypes: ['All'],
  stateFilter: 'All',
  stateList: ['All',
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'],
  company_name: '',
  login_type: TokenService.getLoginType(),
  agencyView: TokenService.getAgencyView(),
  brandView: TokenService.getBrandView(),
  // Controls whether Distributor filter should be shown for this client
  distributorView: (TokenService.getDistributorView && TokenService.getDistributorView()) || '0',
  company_logo: '',
  retail: {'retail_code': TokenService.getLoginCode(), 'retail_name': ''},
  client: {'client_id': 0,
    'client_name': '',
    client_code: TokenService.getLoginCode(),
    'disabled': 0,
    'contact_name': null,
    'contact_email': null,
    'contact_phone': null,
    'notes': null,
    'pos_required': null,
    'az_client_license': null},
  accessKey: TokenService.getAccessKey(),
  authenticating: false,
  authenticationErrorCode: 0,
  authenticationError: '',
  statistics: {
    demos: 0,
    locations: 0,
    customers: 0,
    bottles: 0,
    samples: 0,
    stocked: 0,
    packs: 0
  },
  recaps: [{
    address: '',
    adequate_product: 'yes',
    bottles_sold: '0',
    check_in_name: '',
    check_in_title: '',
    city: '',
    cluster: 0,
    comments: '',
    conducted_where: '',
    contact_first: null,
    contact_last: null,
    costco_id: '',
    country: '',
    coupons: 'no',
    cp_region: '',
    department_staffed: 'no',
    district: '',
    export_id: 0,
    first_name: '',
    hours: 0,
    how_many_customers: 0,
    how_many_poured: 0,
    invoice_id: 0,
    last_name: '',
    lat: 0,
    location: null,
    lon: 0,
    notes: null,
    promo_price: null,
    rate_hour: 0,
    recap_id: 0,
    schedule_id: 0,
    special_instructions: null,
    state: '',
    station_setup: null,
    status: 'expt',
    status_teamleader: null,
    store_director: '0',
    storehours: null,
    storename: '',
    time_end: '18:00:00',
    time_start: '14:30:00',
    timesheet_date: '',
    timesheet_id: 0,
    total: 0,
    traffic: 'Medium',
    type: 'sw',
    url: null,
    user_id: 0,
    warehouse_id: '',
    zipcode: '95350',
    pdf: '',
    html: ''
  }],

  schedule: []

}
